var React = require('react');

function XThinMd (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m2.5.375-2.125 2.125 1.063 1.063 12.438 12.438-12.438 12.438-1.063 1.063 2.125 2.125 1.063-1.063 12.438-12.438 12.438 12.438 1.063 1.063 2.125-2.125-1.063-1.063-12.438-12.438 12.438-12.438 1.063-1.063-2.125-2.125-1.063 1.063-12.438 12.438-12.438-12.438-1.063-1.063z"}));
}

XThinMd.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = XThinMd;

XThinMd.default = XThinMd;
